module.exports = __webpack_public_path__ + "img/invite_wechat.1775439203884.png";